import { numberFormat } from '@/src/shared/utils'

export const MAX_PASTE_ROWS = 35_136 // number of 15 mins intervals in a leap year
export const MAX_PASTE_CELLS = 140_544

const countUpTo = (haystack: string, pattern: RegExp, limit: number): number => {
  let count = 0
  pattern.lastIndex = 0

  while (pattern.exec(haystack) !== null) {
    count++
    if (count > limit) return count
  }

  return count
}

export const getPasteSize = (clipboardData: DataTransfer | null): { rows: number; cells: number } => {
  const plain = clipboardData?.getData('text/plain') ?? ''
  const html = clipboardData?.getData('text/html') ?? ''

  const plainRows = plain === '' ? 0 : countUpTo(plain, /\n/g, MAX_PASTE_ROWS) + 1
  const htmlRows = countUpTo(html, /<tr[\s/>]/gi, MAX_PASTE_ROWS)
  const rows = Math.max(plainRows, htmlRows)

  const firstLineEnd = plain.indexOf('\n')
  const firstLine = firstLineEnd === -1 ? plain : plain.slice(0, firstLineEnd)
  const columns = countUpTo(firstLine, /\t/g, MAX_PASTE_CELLS) + 1

  return { rows, cells: rows * columns }
}

export const isPasteTooLarge = (clipboardData: DataTransfer | null): boolean => {
  const { rows, cells } = getPasteSize(clipboardData)
  return rows > MAX_PASTE_ROWS || cells > MAX_PASTE_CELLS
}

export const formatValueForDisplay = (value: string | number, format?: 'number' | 'text'): string => {
  if (format !== 'number') return String(value ?? '')
  if (value === null || value === undefined || value === '') return ''
  const num = typeof value === 'string' ? Number.parseFloat(value) : value
  if (Number.isNaN(num)) return ''
  return numberFormat(num, 2, 0)
}

export const normalizeNumber = (cell: string): string => {
  let value = cell.replace(/[^\d.,]/g, '')
  const hasComma = value.includes(',')
  const hasPeriod = value.includes('.')

  if (hasComma && hasPeriod) {
    if (value.lastIndexOf('.') > value.lastIndexOf(',')) {
      value = value.replace(/,/g, '')
    } else {
      value = value.replace(/\./g, '').replace(',', '.')
    }
  } else if (hasComma) {
    value = value.replace(',', '.')
  }

  value = value.replace(/(\..*)\./g, '$1')
  return value
}
